import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { selectLanguage } from 'features/userSettings/selectors'

import { getDescriptionByCurrentPayment } from '../../data'

import './DescriptionBlock.scss'

const b = block('description-block')

export const DescriptionBlock: React.FC<{ paymentKey: string }> = ({ paymentKey }) => {
  const lang = useSelector(selectLanguage, shallowEqual)

  const descriptionData = useMemo(() => getDescriptionByCurrentPayment({ lang, paymentKey }), [lang, paymentKey])

  if (!descriptionData.__html) return null

  return (
    <div className={b()}>
      <div dangerouslySetInnerHTML={descriptionData} className={b('text')} />
    </div>
  )
}
